




































import Vue, { PropType } from 'vue';
import TheGeneralSettings from '@/components/campaign/settings/TheGeneralSettings.vue';
import TheLimits from '@/components/campaign/settings/TheLimits.vue';
import TheSchedule from '@/components/campaign/settings/TheSchedule.vue';
import { CampaignSettingsIntarface } from '@/types/campaign/settings';
import Preloader from '@/components/preloader/Preloader.vue';
import TheInventory from '@/components/campaign/settings/TheInventory.vue';
import TheBuyingStrategy from '@/components/campaign/settings/TheBuyingStrategy.vue';

export default Vue.extend({
  name: 'TheSettings',
  components: {
    TheGeneralSettings,
    TheLimits,
    TheSchedule,
    Preloader,
    TheInventory,
    TheBuyingStrategy,
  },

  props: {
    data: {
      type: Object as PropType<CampaignSettingsIntarface>,
      required: true,
    },
  },

  methods: {
    changeSettings(name, value) {
      this.$emit('changeCampaign', name, value);
    },
    changeScheduleDate(date) {
      this.$emit('changeScheduleDate', date);
    },
    changeScheduleTime(time) {
      this.$emit('changeScheduleTime', time);
    },
    changeErrors(name, value) {
      this.$emit('changeErrors', name, value);
    },
  },
});
